// AUTO-GENERATED by scripts/build-registry.js: study entry for aeronautics/obstacle-marking-lighting.
import { mount } from '#engine/lesson-page.js';
import g0 from '../lessons/aeronautics/obstacle-marking-lighting/obstacle-marking-and-lighting.js';
import g1 from '../lessons/aeronautics/obstacle-marking-lighting/obstacle-marking-lighting.js';

mount([g0, g1]);
